module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f889cdd86f37f932db0f7a72dff7039c.png";